// extracted by mini-css-extract-plugin
export var innerPoup = "Popup-module--innerPoup--149b2";
export var popup = "Popup-module--popup--49fcc";